/* World Feast: "Add to your Feast" upsell card inside the Slide Cart drawer (slidecarthq).
 * Data: <script id="wf-basket-upsell-data"> from snippets/wf-basket-upsell.liquid (per cuisine, max two products).
 * The app re-renders its DOM often, so a MutationObserver re-inserts the card after .items when it goes missing.
 * Option 1 shows "Free" (original price struck through) while FEASTING is applicable on the cart.
 * Does nothing if the slide cart is absent. Reads the cart via /cart.js; adds via /cart/add.js, then SLIDECART_UPDATE().
 */
(function () {
  'use strict';
  var dataEl = document.getElementById('wf-basket-upsell-data');
  if (!dataEl) return;
  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var CODE = 'FEASTING';
  var cart = null, cartSig = '', renderedSig = null, fetching = false, pending = false, busy = false;
  var card = null, timer = 0, root = null;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    var cur = (cart && cart.currency) || 'GBP';
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '£' + (cents / 100).toFixed(2); }
  }

  /* ── which cuisine is in the basket ── */
  function cuisineOf(item) {
    var t = ((item.handle || '') + ' ' + (item.product_title || '') + ' ' + (item.sku || '')).toLowerCase();
    if (/southindian|south-indian|south indian/.test(t)) return 'southindian';
    if (/vietnam/.test(t)) return 'vietnamese';
    if (/bbq|texas|texan/.test(t)) return 'bbq';
    return '';
  }
  function pageCuisine() {
    var p = location.pathname.toLowerCase();
    if (/south-indian/.test(p)) return 'southindian';
    if (/vietnam/.test(p)) return 'vietnamese';
    if (/texas|bbq/.test(p)) return 'bbq';
    return '';
  }
  function pickCuisine() {
    var seen = {}, n = 0;
    (cart.items || []).forEach(function (it) { var c = cuisineOf(it); if (c && !seen[c]) { seen[c] = 1; n++; } });
    if (n === 1) return Object.keys(seen)[0];
    var pc = pageCuisine();
    return (n === 0 || n > 1) && pc ? pc : '';   // mixed or unknown: fall back to the page's cuisine, else hide
  }
  function feastingOn() {
    var codes = (cart && cart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) if (String(codes[i].code).toUpperCase() === CODE && codes[i].applicable) return true;
    return false;
  }
  /* When may option 1 say "Free"? The FEASTING function makes ONE unit of the CHEAPEST eligible line free, for
   * new customers only. So "Free" is only true if (a) FEASTING is applicable, (b) the customer has no past orders
   * and (c) no line already has a free unit (its discount >= one original unit price), unless this option is
   * strictly cheaper than that free line (it would become the cheapest, so it takes over the free unit).
   * Returns the price (cents) the option must beat, Infinity if nothing is free yet, or -1 if "Free" is not allowed. */
  function freeCeiling() {
    if (!feastingOn()) return -1;
    var cfg = window.WF_OFFER_CFG || {};
    if (cfg.customerOrders > 0) return -1;
    var ceil = Infinity;
    (cart.items || []).forEach(function (it) {
      var unit = it.original_price, off = Number(it.total_discount) || 0;
      if (unit > 0 && off >= unit) ceil = Math.min(ceil, unit);
    });
    return ceil;
  }

  /* ── build the card ── */
  function build() {
    var el = document.createElement('div');
    el.className = 'wf-up';
    el.setAttribute('data-wf-upsell', '');
    el.setAttribute('role', 'region');
    el.setAttribute('aria-label', 'Add to your Feast');
    el.hidden = true;
    el.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-up-add]');
      if (b) add(b);
    });
    return el;
  }
  function inCart(p) {
    return (cart.items || []).some(function (it) { return it.variant_id === p.variant || it.handle === p.handle; });
  }
  function fill() {
    var cuisine = cart && cart.item_count ? pickCuisine() : '';
    var list = (cuisine && DATA[cuisine] || []).filter(function (p) { return !inCart(p); });
    var ceil = freeCeiling();
    var sig = cuisine + '|' + ceil + '|' + list.map(function (p) { return p.variant; }).join(',');
    if (sig === renderedSig) return;
    renderedSig = sig;
    if (!list.length) { card.hidden = true; card.innerHTML = ''; return; }
    var tiles = list.map(function (p) {
      var isFree = ceil !== -1 && p.slot === 1 && p.price < ceil;
      var price = isFree
        ? '<span class="wf-up__price wf-up__price--free"><span>Free</span><s>' + esc(money(p.price)) + '</s></span>'
        : '<span class="wf-up__price">' + esc(money(p.price)) + '</span>';
      return '<div class="wf-up__tile"' + (list.length === 1 ? ' data-single' : '') + ' role="group" aria-label="' + esc(p.title) + '">' +
        (p.image ? '<div class="wf-up__imgbox"><img class="wf-up__img" src="' + esc(p.image) + '" alt="" loading="lazy" width="76" height="76"></div>' : '') +
        '<div class="wf-up__body"><p class="wf-up__name">' + esc(p.title) + '</p>' + price +
        '<button type="button" class="wf-up__btn" data-up-add data-variant="' + p.variant + '" data-handle="' + esc(p.handle) + '" aria-label="Add ' + esc(p.title) + '">Add</button></div></div>';
    }).join('');
    card.innerHTML = '<div class="wf-up__head"><h3 class="wf-up__title">Add to your Feast</h3>' +
      (list.length > 1 ? '<span class="wf-up__hint" aria-hidden="true">Swipe for more &rsaquo;</span>' : '') + '</div>' +
      '<div class="wf-up__track" tabindex="0" role="group" aria-label="Suggestions">' + tiles + '</div>';
    card.hidden = false;
  }

  /* ── keep it in the drawer ── */
  function ensure() {
    root = document.getElementById('slidecarthq');
    if (!root) return;
    var dialog = root.querySelector('[role="dialog"]');
    var items = dialog && dialog.querySelector('.items');
    if (!items) { if (card && card.parentNode) card.parentNode.removeChild(card); return; }   // empty cart view
    if (!card) card = build();
    if (items.nextElementSibling !== card) items.insertAdjacentElement('afterend', card);
    var sig = Array.prototype.map.call(items.querySelectorAll('[data-line-item-key]'), function (n) { return n.getAttribute('data-line-item-key') + ':' + (n.querySelector('input') ? n.querySelector('input').value : ''); }).join(',');
    if (sig !== cartSig || !cart) { cartSig = sig; refresh(); }
    else if (cart) fill();
  }
  function refresh() {
    if (fetching) { pending = true; return; }
    fetching = true;
    fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; fetching = false; if (card && card.isConnected) fill(); if (pending) { pending = false; refresh(); } })
      .catch(function () { fetching = false; });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(ensure, 120); }

  function add(btn) {
    if (busy) return;
    busy = true; btn.disabled = true; btn.textContent = 'Adding…';
    var handle = btn.getAttribute('data-handle');
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant')), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () {
        try { if (window.WF && typeof window.WF.event === 'function') window.WF.event('basket_upsell_add', { handle: handle }); } catch (e) {}
        cartSig = '';
        if (typeof window.SLIDECART_UPDATE === 'function') { try { window.SLIDECART_UPDATE(); } catch (e) {} }
        refresh();
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Try again'; })
      .then(function () { busy = false; });
  }

  /* ── hooks: chain, never replace ── */
  function chain(name) {
    var prev = window[name];
    window[name] = function () {
      var r; if (typeof prev === 'function') { try { r = prev.apply(this, arguments); } catch (e) { setTimeout(function () { throw e; }); } }
      cartSig = ''; schedule(); return r;
    };
  }
  function start() {
    chain('SLIDECART_OPENED'); chain('SLIDECART_UPDATED');
    document.addEventListener('wf:discount', function () { renderedSig = null; refresh(); });
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
